import { zefDialogOpen } from '@zerops/zef/dialog';
import { FEATURE_NAME } from './token-add-edit-dialog.constant';
import { TokenAddEditMode, TokenAddEditDialogMeta } from './token-add-edit.model';

// Helper function to open dialog with mode
export const tokenAddEditDialogOpen = (
  mode: TokenAddEditMode,
  tokenId?: string
) =>
  zefDialogOpen({
    key: FEATURE_NAME,
    meta: {
      mode,
      ...(tokenId && { tokenId })
    } as TokenAddEditDialogMeta
  });
